<script>
    import axios from 'axios'
    import * as VueGoogleMaps from 'vue2-google-maps';
    import vSelect from 'vue-select'
    import Vue from 'vue'

    if (window.googleMapsAPI) {
        Vue.use(VueGoogleMaps, {
            load: {
                key: window.googleMapsAPI,
                libraries: 'places',
            }
        });
    }
    export default {
        components: {
            'vue-google-autocomplete': VueGoogleMaps.Autocomplete,
            'google-map': VueGoogleMaps.Map,
            'google-marker': VueGoogleMaps.Marker,
            'v-select': vSelect
        },
        name: "stepOne",
        props: {'course': Object, 'companies': null, 'companyprop': null},
        data() {
            return {
                loading: false,
                hasBody: false,
                sport: null,
                message: null,
                types: ['geocode'],
                sports: [],
                federations: [],
                bodies: [],
                selectedCompany: null,
                company: {}

            }
        },
        computed: {
            center() {
                if (this.course.latitude && this.course.longitude) {
                    return {
                        lat: this.course.latitude,
                        lng: this.course.longitude
                    }
                }
            }
        },
        mounted() {
            var self = this;

            this.sport_search_string = '';
            this.getFederations();
            this.getBodies();

            this.selectedCompany = this.companyprop.id
            this.setCompany(this.selectedCompany)

            this.search(this.sport_loading, this.sport_search_string, this);

            $('#selectSport').select2();

            if (self.course) {
                $('#selectSport').val(self.course.sportId).trigger('change');
            }
        },
        watch: {
            selectedCompany(val) {
                if (_.isNumber(val)) {
                    this.setCompany(val)
                }
            },
            'course.sportId'() {
                if (!this.sport) {
                    this.getSport(this.course.sportId);
                }
            },
            'sport'() {
                if (this.sport) {
                    this.course.sportId = this.sport.id;
                }
            },
            'course.address'() {
                if ($('#autocomplete_error').length) {
                    document.getElementById("autocomplete_error").remove();
                }
            }
        },
        methods: {
            setCompany(val) {
                let company = _.head(this.companies.filter(i => i.id === val))
                this.$set(this, 'company', company)
            },
            putAlertOnAutocomplete() {

                if (!$('#autocomplete_error').length) {
                    $('#where_is_the_course').after(
                        '<p id="autocomplete_error" class="t-16 text-danger">Inizia a digitare l\'indirizzo e seleziona quello corretto dai suggerimenti.\n' +
                        'L\'indirizzo viene registrato correttamente quando vedi apparire la mappa.</p>'
                    )
                }

                $('html, body').animate({
                    scrollTop: $("#selectCourseSport").offset().top
                }, 1000);
            },
            onSearch(search, loading) {
                this.sport_search_string = search;
                this.sport_loading = loading;
            },
            search: _.debounce((loading, search, vm) => {
                axios({
                    method: 'get',
                    url: '/sports/search?q=' + search
                }).then((response) => {
                    vm.sports = response.data.sports;
                    loading(false);
                }).catch((error) => {
                    vm.message = 'Error';
                });
            }),
            getSport(sportId) {
                var self = this;

                axios({
                    method: 'get',
                    url: '/sports/' + sportId
                }).then((response) => {
                    this.sport = response.data.sport;

                }).catch((error) => {
                    self.message = 'Error';
                });
            },
            getFederations() {
                axios({
                    method: 'get',
                    url: '/federations'
                }).then((response) => {
                    this.federations = response.data.federations;

                }).catch((error) => {
                    this.message = 'Error';
                });
            },
            getBodies() {
                var self = this;

                axios({
                    method: 'get',
                    url: '/bodies'
                }).then((response) => {
                    self.bodies = response.data.bodies;

                }).catch((error) => {
                    self.message = 'Error';
                });
            },
            triggerPlaceChanged() {
                const el = this.$refs.addressComponent.$refs.input;
                el.focus();
                const ev = new Event('keydown');
                ev.which = 40;
                ev.keyCode = 40;
                el.dispatchEvent(ev);
            },
            isLoading() {
                return this.loading;
            },
            getAddressData(payload) {
                this.course.address = payload.formatted_address;
                this.course.addressComponents = payload.address_components;
                this.course.latitude = payload.geometry.location.lat();
                this.course.longitude = payload.geometry.location.lng();
            },
            postForm() {
                if (!this.course.address) {
                    return this.putAlertOnAutocomplete();
                }

                this.loading = true;
                this.$bus.$emit('searching');

                if (this.course.hasFederation && this.course.federationId == null) {
                    this.message = 'Seleziona una federazione';

                    this.loading = false;
                    this.$bus.$emit('filtered');
                } else {
                    if (this.course.addressComponents === null && this.course.address === null) {
                        this.triggerPlaceChanged();
                        this.loading = false;
                        this.$bus.$emit('filtered');
                        return;
                    } else if (this.course.addressComponents === null && this.course.address !== null) {
                        this.course.addressComponents = false;
                    }
                    this.course.sportId = this.sport.id;
                    this.course.companyId = this.selectedCompany;

                    let company = _.head(this.companies.filter(i => i.id == this.selectedCompany))
                    console.log('company', company)
                    if (this.course.courseId) {
                        axios({
                            method: 'put',
                            url: '/courses/' + this.course.courseId,
                            data: {
                                course: this.course,
                                body_id: company.body_id
                            }
                        }).then((response) => {
                            this.loading = false;
                            this.$bus.$emit('filtered');
                            this.$emit('update-step', 2);
                        }).catch((error) => {
                            this.loading = false;
                            this.$bus.$emit('filtered');
                            this.message = 'Error';
                        });
                    }
                    else {
                        axios({
                            method: 'post',
                            url: '/courses',
                            data: {
                                course: this.course,
                                body_id: company.body_id
                            }
                        }).then((response) => {
                            this.course.slug = response.data.course.slug;
                            this.loading = false;
                            this.$bus.$emit('stop-spinner');
                            this.$bus.$emit('filtered');
                            this.$bus.$emit('course-created', response.data.course);
                            this.$emit('update-step', 2);
                            this.$emit('update-course-id', response.data.course.id);
                        }).catch((error) => {
                            this.message = 'Error';
                        });
                    }

                }
            }
        },
        directives: {
            selectsport: {
                twoWay: true,
                bind: function (el, binding, vnode) {
                    $(el).select2()
                        .on("select2:select", function (e) {
                            vnode.context.sports.forEach(function (sport) {
                                if (sport.id == $(el).val()) {
                                    vnode.context.sport = sport;
                                }
                            });

                            vnode.context.course.sport_id = $(el).val();
                        }.bind(this));
                },
                update: function (el) {
                    $(el).trigger("change");
                }
            },
        },
    }
</script>
<style scoped>
    label {
        display: inline;
    }

    .custom-control-input {
        background-color: #17BEBB;
        border: 1px solid #adb8c0;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05), inset 15px 10px -12px rgba(255, 255, 255, 0.1);
        color: #99a1a7;
    }

    input:checked {
        background-color: #17BEBB;
        border: 1px solid #adb8c0;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05), inset 15px 10px -12px rgba(255, 255, 255, 0.1);
        color: #99a1a7;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/course/StepOne.vue